// react
import React from 'react';

// third-party
import { Helmet } from 'react-helmet-async';

// application
import EmptyState from '../shared/EmptyState';
import theme from '../../data/theme';

function SitePageNotFound() {
    return (
        <div className="not-found-page-wrapper">
            <Helmet>
                <title>{`Halaman Tidak Ada | ${theme.name}`}</title>
            </Helmet>

            <div className="container">
                <EmptyState
                    icon="404"
                    title="Halaman Tidak Ada"
                    text="Halaman yang kamu cari tidak ditemukan atau sedang tidak tersedia."
                    actionLabel="Mulai Belanja"
                    actionTo="/"
                    actionIcon="shopping-bag"
                />
            </div>
        </div>
    );
}

export default SitePageNotFound;
